import { WorkflowItem } from "./WorkflowItem";

export class Workflow
{
  constructor(
    public id?: string,
    public name?: string,
    public items: WorkflowItem[] = [],
    public editMode: boolean = false,
    public stopAfterOneFailure?:boolean,
    public failureMailsRecipients?: string,

  ) { }

}

